import type { Translations } from '../types';

/** Français */
export const fr: Translations = {
  'app.name': 'ITA6',
  'app.tagline': 'Concours en ligne fondés sur la compétence',
  'app.skipToContent': 'Aller au contenu principal',

  'nav.primary': 'Navigation principale',
  'nav.openMenu': 'Ouvrir le menu',
  'nav.closeMenu': 'Fermer le menu',
  'nav.home': 'Accueil',
  'nav.dashboard': 'Tableau de bord',
  'nav.profile': 'Profil',
  'nav.admin': 'Administration',
  'nav.signIn': 'Se connecter',
  'nav.signOut': 'Se déconnecter',
  'nav.createAccount': 'Créer un compte',

  'role.user': 'Participant',
  'role.admin': 'Administrateur',
  'role.userShort': 'participant',
  'role.adminShort': 'admin',

  'status.active': 'actif',
  'status.suspended': 'suspendu',
  'status.deleted': 'supprimé',
  'status.verified': 'vérifié',
  'status.notVerified': 'non vérifié',

  'common.loading': 'Chargement…',
  'common.refresh': 'Actualiser',
  'common.yes': 'Oui',
  'common.no': 'Non',
  'common.backToHome': 'Retour à l’accueil',
  'common.backToDashboard': 'Retour au tableau de bord',
  'common.backToContest': 'Retour au concours',
  'common.notAvailable': 'Indisponible',

  'theme.label': 'Thème',
  'theme.light': 'Clair',
  'theme.dark': 'Sombre',
  'theme.system': 'Système',

  'language.label': 'Langue',

  'home.hero.title': 'Prouvez votre compétence.',
  'home.hero.titleAccent': 'Gagnez au mérite.',
  'home.hero.subtitle':
    'ITA6 est une plateforme de concours fondés sur la compétence. Participez à des concours de talent, relevez des défis chronométrés à réponses objectives, et laissez des règles de notation publiées — et non le hasard — désigner les gagnants.',
  'home.hero.goToDashboard': 'Aller au tableau de bord',
  'home.hero.createAccount': 'Créer votre compte',
  'home.hero.signIn': 'Se connecter',
  'home.highlights.title': 'Ce que propose ITA6',
  'home.highlights.contests': 'Parcourir les concours et voir le nombre de participants',
  'home.highlights.prizes': 'Des cagnottes transparentes financées par les frais d’inscription',
  'home.highlights.timed': 'Des défis chronométrés notés de façon objective par la plateforme',
  'home.highlights.results': 'Des classements tenant compte des égalités et des résultats publiés',
  'home.highlights.admin': 'Une administration par rôles : concours, utilisateurs et paiements',
  'home.highlights.note':
    'Les inscriptions ouvrent bientôt. Créez votre compte maintenant pour être prêt dès le premier jour.',
  'home.features.title': 'Conçu pour l’équité',
  'home.features.subtitle':
    'Chaque choix de conception sert un seul objectif : que le participant le plus habile gagne.',
  'home.features.skill.title': 'La compétence, pas la chance',
  'home.features.skill.body':
    'Les concours se décident sur la performance objective. Les gagnants résultent de règles de notation publiées — jamais d’un tirage au sort.',
  'home.features.scoring.title': 'Notation objective',
  'home.features.scoring.body':
    'Les réponses sont évaluées et chronométrées par la plateforme elle-même : un score ne peut pas être modifié depuis un navigateur.',
  'home.features.standing.title': 'Classements transparents',
  'home.features.standing.body':
    'Nombre de participants, cagnottes et classements sont visibles par chaque participant, avant et après le résultat.',
  'home.features.accounts.title': 'Un compte pour tous les concours',
  'home.features.accounts.body':
    'Un profil vérifié unique suit vos participations, vos résultats et vos gains sur toute la plateforme.',
  'home.steps.title': 'Comment se déroule un concours',
  'home.steps.one.title': 'Créez votre profil',
  'home.steps.one.body': 'Inscrivez-vous une fois et vous êtes prêt pour tous les concours.',
  'home.steps.two.title': 'Participez à un concours',
  'home.steps.two.body': 'Payez les frais d’inscription d’un concours qui correspond à vos intérêts.',
  'home.steps.three.title': 'Relevez le défi',
  'home.steps.three.body':
    'Répondez à des questions objectives chronométrées, dans un temps équitable imposé par la plateforme.',
  'home.steps.four.title': 'Découvrez votre classement',
  'home.steps.four.body':
    'Obtenez un score objectif et grimpez dans un classement transparent tenant compte des égalités.',
  'home.cta.title': 'Prêt à tester votre compétence ?',
  'home.cta.body': 'Créez un compte gratuit et soyez prêt dès l’ouverture des premiers concours.',
  'home.cta.button': 'Commencer',

  'login.title': 'Bon retour',
  'login.subtitle': 'Connectez-vous à votre compte ITA6.',
  'login.cardTitle': 'Connexion',
  'login.cardDescription': 'Utilisez l’adresse e-mail et le mot de passe de votre inscription.',
  'login.email': 'Adresse e-mail',
  'login.emailPlaceholder': 'vous@exemple.com',
  'login.password': 'Mot de passe',
  'login.passwordPlaceholder': 'Votre mot de passe',
  'login.submit': 'Se connecter',
  'login.noAccount': 'Vous n’avez pas de compte ?',
  'login.createOne': 'Créez-en un',
  'login.errorRequired': 'Saisissez votre adresse e-mail et votre mot de passe.',
  'login.errorGeneric': 'La connexion a échoué. Veuillez réessayer.',

  'register.title': 'Créer votre compte',
  'register.subtitle': 'Un seul compte pour tous les concours ITA6. L’inscription est gratuite.',
  'register.cardTitle': 'Inscription',
  'register.cardDescription': 'Tous les champs sont obligatoires, sauf le nom affiché.',
  'register.displayName': 'Nom affiché (facultatif)',
  'register.displayNamePlaceholder': 'Le nom visible dans les classements',
  'register.email': 'Adresse e-mail',
  'register.password': 'Mot de passe',
  'register.passwordPlaceholder': 'Au moins {min} caractères',
  'register.confirmPassword': 'Confirmer le mot de passe',
  'register.confirmPlaceholder': 'Répétez votre mot de passe',
  'register.submit': 'Créer le compte',
  'register.securityNote':
    'Votre mot de passe est stocké de manière sécurisée à l’aide d’un hachage conforme aux standards du secteur.',
  'register.haveAccount': 'Vous avez déjà un compte ?',
  'register.signIn': 'Se connecter',
  'register.errorGeneric': 'L’inscription a échoué. Veuillez réessayer.',

  'validation.emailRequired': 'L’adresse e-mail est obligatoire.',
  'validation.emailInvalid': 'Saisissez une adresse e-mail valide.',
  'validation.passwordMin': 'Le mot de passe doit contenir au moins {min} caractères.',
  'validation.passwordComplexity':
    'Le mot de passe doit contenir au moins une lettre et un chiffre.',
  'validation.passwordMismatch': 'Les mots de passe ne correspondent pas.',

  'dashboard.title': 'Bienvenue, {name}',
  'dashboard.subtitle':
    'Voici votre tableau de bord ITA6. Vos concours et résultats apparaîtront ici.',
  'dashboard.adminConsole': 'Console d’administration',
  'dashboard.viewProfile': 'Voir le profil',
  'dashboard.stat.displayName': 'Nom affiché',
  'dashboard.stat.email': 'Adresse e-mail',
  'dashboard.stat.role': 'Rôle',
  'dashboard.stat.memberSince': 'Membre depuis',
  'dashboard.stat.lastLogin': 'Dernière connexion : {date}',
  'dashboard.roleHint.admin': 'Accès administratif complet',
  'dashboard.roleHint.user': 'Accès participant',
  'dashboard.contests.title': 'Vos concours',
  'dashboard.contests.description':
    'Les concours auxquels vous participez seront listés ici avec leur statut et leurs résultats.',
  'dashboard.contests.empty.title': 'Aucun concours pour le moment',
  'dashboard.contests.empty.body':
    'Les inscriptions ouvrent bientôt. Dès que vous participerez à un concours, il apparaîtra ici.',
  'dashboard.account.title': 'Statut du compte',
  'dashboard.account.description': 'L’état actuel de votre compte.',
  'dashboard.account.status': 'Statut',
  'dashboard.account.emailVerified': 'E-mail vérifié',
  'dashboard.account.role': 'Rôle',
  'dashboard.account.id': 'Identifiant du compte',

  'profile.title': 'Votre profil',
  'profile.subtitle':
    'Voici les informations que les autres participants voient avec vos résultats.',
  'profile.details.title': 'Détails du profil',
  'profile.details.description': 'Informations publiques affichées avec vos résultats.',
  'profile.field.displayName': 'Nom affiché',
  'profile.field.country': 'Pays',
  'profile.field.bio': 'Biographie',
  'profile.account.title': 'Détails du compte',
  'profile.account.description': 'Vos informations de compte privées.',
  'profile.field.email': 'Adresse e-mail',
  'profile.field.emailVerified': 'E-mail vérifié',
  'profile.field.role': 'Rôle',
  'profile.field.status': 'Statut',
  'profile.field.memberSince': 'Membre depuis',
  'profile.field.lastLogin': 'Dernière connexion',
  'profile.field.accountId': 'Identifiant du compte',

  'admin.title': 'Console d’administration',
  'admin.subtitle': 'État de la plateforme et accès administratif.',
  'admin.refresh': 'Actualiser',
  'admin.loading': 'Chargement de la console…',
  'admin.errorLoad': 'Impossible de charger l’état de la plateforme.',
  'admin.signedInAs': 'Connecté en tant que',
  'admin.users': 'Utilisateurs',
  'admin.usersSummary': '{admins} administrateurs · {active} actifs',
  'admin.apiLabel': 'API de la plateforme',
  'admin.apiHealthy': 'opérationnelle',
  'admin.apiUnavailable': 'indisponible',
  'admin.database': 'Base de données',
  'admin.databaseOk': 'connectée',
  'admin.databaseUnavailable': 'indisponible',
  'admin.databaseUnknown': 'inconnu',
  'admin.serverTime': 'Heure du serveur : {date}',
  'admin.session.title': 'Session',
  'admin.session.description': 'Votre contexte administrateur authentifié.',
  'admin.field.email': 'Adresse e-mail',
  'admin.field.role': 'Rôle',
  'admin.field.accountId': 'Identifiant du compte',
  'admin.field.statusChecked': 'Statut vérifié',
  'admin.roadmap.title': 'Administration',
  'admin.roadmap.description': 'Ce que vous gérerez depuis cette console.',
  'admin.roadmap.contests': 'Créer et configurer les concours et les défis',
  'admin.roadmap.questions': 'Rédiger les questions et gérer les réponses correctes',
  'admin.roadmap.payments': 'Contrôler les frais d’inscription et les listes de participants',
  'admin.roadmap.results': 'Publier les résultats, les classements et les gains',
  'admin.roadmap.users': 'Modérer les utilisateurs et gérer les paramètres',

  'guard.checkingSession': 'Vérification de votre session…',
  'guard.accessDenied.title': 'Accès refusé',
  'guard.accessDenied.body':
    'Cet espace est réservé aux administrateurs. Si vous pensez y avoir droit, contactez le propriétaire de la plateforme.',

  'notFound.title': 'Page introuvable',
  'notFound.body': 'La page recherchée n’existe pas ou a été déplacée.',

  'api.networkError': 'Impossible de joindre ITA6. Vérifiez votre connexion et réessayez.',
  'api.requestFailed': 'Une erreur est survenue. Veuillez réessayer.',
  'api.invalidCredentials': 'Adresse e-mail ou mot de passe incorrect.',
  'api.emailTaken': 'Un compte existe déjà avec cette adresse e-mail.',
  'api.accountInactive': 'Ce compte n’est pas actif.',
  'api.sessionExpired': 'Votre session a expiré. Veuillez vous reconnecter.',
  'api.unauthorized': 'Veuillez vous connecter pour continuer.',
  'api.forbidden': 'Vous n’êtes pas autorisé à effectuer cette action.',
  'api.invalidEmail': 'Saisissez une adresse e-mail valide.',
  'api.weakPassword': 'Le mot de passe ne respecte pas les exigences.',
  'api.internalError': 'Une erreur est survenue de notre côté. Veuillez réessayer.',

  'footer.copyright': '© {year} ITA6. Tous droits réservés.',
  'footer.legal': 'Mentions légales',
  'footer.terms': 'Conditions',
  'footer.privacy': 'Confidentialité',
  'footer.contact': 'Contact',

  // --- Phase 2 : le monde des concours -------------------------------------
  'nav.contests': 'Concours',
  'nav.myEntries': 'Mes participations',
  'nav.adminContests': 'Gestion des concours',
  'nav.adminPayments': 'Paiements',

  'common.save': 'Enregistrer',
  'common.cancel': 'Annuler',
  'common.close': 'Fermer',
  'common.confirm': 'Confirmer',
  'common.actions': 'Actions',
  'common.status': 'Statut',
  'common.amount': 'Montant',
  'common.date': 'Date',
  'common.none': 'Aucun',
  'common.submit': 'Envoyer',
  'common.details': 'Détails',
  'common.optional': 'facultatif',
  'common.rail': 'Canal de paiement',
  'common.asset': 'Actif',

  'rail.all': 'Tous les concours',
  'rail.fiat': 'Monnaie classique',
  'rail.crypto': 'Crypto',

  'contest.phase.draft': 'Brouillon',
  'contest.phase.scheduled': 'Programmé',
  'contest.phase.registration_open': 'Inscriptions ouvertes',
  'contest.phase.registration_closed': 'Inscriptions closes',
  'contest.phase.live': 'En cours',
  'contest.phase.awaiting_results': 'En attente des résultats',
  'contest.phase.results_ready': 'Résultats disponibles',
  'contest.phase.cancelled': 'Annulé',
  'contest.phase.voided': 'Invalidé',

  'participant.status.registered': 'Inscrit',
  'participant.status.awaiting_payment': 'En attente de paiement',
  'participant.status.confirmed': 'Confirmé',
  'participant.status.active': 'En cours',
  'participant.status.completed': 'Terminé',
  'participant.status.disqualified': 'Disqualifié',
  'participant.status.withdrawn': 'Retiré',
  'participant.status.refunded': 'Remboursé',

  'payment.status.pending': 'En attente de paiement',
  'payment.status.confirmed': 'Payé',
  'payment.status.failed': 'Échoué',
  'payment.status.expired': 'Expiré',
  'payment.status.refunded': 'Remboursé',
  'payment.status.cancelled': 'Annulé',

  'payout.status.pending': 'En attente',
  'payout.status.approved': 'Approuvé',
  'payout.status.processing': 'En traitement',
  'payout.status.completed': 'Payé',
  'payout.status.failed': 'Échoué',
  'payout.status.cancelled': 'Annulé',
  'payout.kind.prize': 'Prix',
  'payout.kind.refund': 'Remboursement',

  'contest.list.title': 'Concours',
  'contest.list.subtitle': 'Parcourez les concours ouverts, consultez la cagnotte et participez.',
  'contest.list.empty': 'Aucun concours ouvert pour le moment. Revenez bientôt.',
  'contest.list.loadError': 'Impossible de charger les concours.',
  'contest.list.view': 'Voir le concours',

  'contest.card.entry': "Frais d'inscription",
  'contest.card.free': 'Gratuit',
  'contest.card.prizePool': 'Cagnotte',
  'contest.card.participants': '{count} inscrits',
  'contest.card.startsAt': 'Début {date}',
  'contest.card.endsAt': 'Fin {date}',

  'contest.countdown.opens': 'Ouverture des inscriptions dans',
  'contest.countdown.closes': 'Clôture des inscriptions dans',
  'contest.countdown.starts': 'Début dans',
  'contest.countdown.ends': 'Fin dans',
  'contest.countdown.past': 'Clos',


  'contest.detail.notFound': 'Ce concours est introuvable.',
  'contest.detail.loadError': 'Impossible de charger ce concours.',
  'contest.detail.about': 'À propos de ce concours',
  'contest.detail.rules': 'Règlement',
  'contest.detail.prizePool': 'Cagnotte',
  'contest.detail.entryFee': "Frais d'inscription",
  'contest.detail.asset': 'Actif',
  'contest.detail.paidPlaces': 'Places récompensées',
  'contest.detail.minParticipants': 'Participants minimum',
  'contest.detail.questions': 'Questions',
  'contest.detail.secondsPerQuestion': 'Secondes par question',
  'contest.detail.tieBreak': 'Départage',
  'contest.detail.signInToEnter': 'Connectez-vous pour participer',
  'contest.detail.register': 'Participer au concours',
  'contest.detail.registering': 'Inscription…',
  'contest.detail.registered': 'Vous êtes inscrit',
  'contest.detail.start': 'Commencer le concours',
  'contest.detail.continue': 'Reprendre le concours',
  'contest.detail.viewResults': 'Voir les résultats',
  'contest.detail.payNow': 'Ouvrir la page de paiement',
  'contest.detail.paymentPending': "Votre inscription attend la confirmation du paiement.",
  'contest.detail.paymentConfirmed': 'Votre paiement est confirmé.',
  'contest.detail.paymentRequired': "Ce concours comporte des frais d'inscription.",
  'contest.detail.providerNotConfigured':
    "Le paiement en ligne n'est pas encore disponible. Contactez l'organisateur, qui peut confirmer votre inscription manuellement.",
  'contest.detail.enterError': "Impossible de participer à ce concours.",
  'contest.detail.cancelled': 'Ce concours a été annulé.',
  'contest.detail.voided': 'Ce concours a été invalidé et les frais remboursés.',

  'contest.play.title': 'Concours en cours',
  'contest.play.questionProgress': 'Question {current} sur {total}',
  'contest.play.timeLeft': 'Temps restant',
  'contest.play.submit': 'Envoyer la réponse',
  'contest.play.submitting': 'Envoi…',
  'contest.play.submitted': 'Réponse enregistrée',
  'contest.play.answered': 'Répondu',
  'contest.play.numericPlaceholder': 'Saisissez un nombre, par ex. 12.5',
  'contest.play.multiHint': 'Sélectionnez toutes les bonnes réponses. Une réponse partielle ne rapporte rien.',
  'contest.play.next': 'Question suivante',
  'contest.play.previous': 'Précédent',
  'contest.play.finish': 'Terminer le concours',
  'contest.play.finishing': 'Finalisation…',
  'contest.play.noAnswers':
    "Vous n'avez encore envoyé aucune réponse. Terminer maintenant mettra fin à votre tentative.",
  'contest.play.error': "Cette réponse n'a pas pu être enregistrée.",
  'contest.play.loadError': 'Impossible de charger le concours.',
  'contest.play.notStarted': "Commencez d'abord le concours depuis sa page.",
  'contest.play.finishedTitle': 'Concours terminé',
  'contest.play.yourScore': 'Votre score',
  'contest.play.correctAnswers': 'Bonnes réponses',
  'contest.play.answeredCount': 'Réponses enregistrées',
  'contest.play.timeUsed': 'Temps utilisé',
  'contest.play.meanwhile': "Le classement final apparaîtra dès sa publication par l'organisateur.",

  'contest.results.title': 'Résultats',
  'contest.results.notPublished': "Les résultats de ce concours n'ont pas encore été publiés.",
  'contest.results.empty': 'Aucun résultat à afficher.',
  'contest.results.loadError': 'Impossible de charger les résultats.',
  'contest.results.winners': 'Gagnants',
  'contest.results.leaderboard': 'Classement final',
  'contest.results.rank': 'Rang',
  'contest.results.participant': 'Participant',
  'contest.results.score': 'Score',
  'contest.results.correct': 'Correctes',
  'contest.results.time': 'Temps',
  'contest.results.prize': 'Prix',
  'contest.results.export': 'Exporter en CSV',
  'contest.results.review': 'Revoir les réponses',
  'contest.results.correctAnswer': 'Bonne réponse',
  'contest.results.explanation': 'Explication',


  'entries.title': 'Mes participations',
  'entries.subtitle': 'Tous les concours auxquels vous avez participé, avec votre résultat et vos gains.',
  'entries.empty': "Vous n'avez encore participé à aucun concours.",
  'entries.loadError': 'Impossible de charger vos participations.',
  'entries.contest': 'Concours',
  'entries.viewContest': 'Ouvrir le concours',
  'entries.noResult': 'Pas encore de résultat',
  'entries.myPayouts': 'Mes paiements',
  'entries.payoutsEmpty': "Vous n'avez encore aucun paiement.",

  'admin.queue.title': 'Opérations',
  'admin.queue.description': 'Concours, paiements des inscriptions et sommes dues.',
  'admin.queue.payments': 'Paiements en attente',
  'admin.queue.payouts': 'Versements en attente',
  'admin.queue.reconciliation': 'Signalés pour rapprochement',

  'admin.contests.title': 'Concours',
  'admin.contests.subtitle': 'Créez des concours, rédigez les questions et pilotez le cycle de vie.',
  'admin.contests.create': 'Nouveau concours',
  'admin.contests.empty': 'Aucun concours pour le moment.',
  'admin.contests.loadError': 'Impossible de charger les concours.',
  'admin.contests.formHeading': 'Créer un concours',
  'admin.contests.formHint':
    "Les frais d'inscription, l'actif et les horaires sont figés dès la sortie du brouillon : vérifiez-les attentivement.",
  'admin.contests.field.title': 'Titre',
  'admin.contests.field.summary': 'Résumé court',
  'admin.contests.field.description': 'Description',
  'admin.contests.field.rules': 'Règlement',
  'admin.contests.field.rail': 'Canal de paiement',
  'admin.contests.field.asset': 'Actif',
  'admin.contests.field.entryFee': "Frais d'inscription (par ex. 10.00)",
  'admin.contests.field.sponsor': 'Financement du sponsor (facultatif)',
  'admin.contests.field.feeBps': 'Commission de la plateforme (points de base)',
  'admin.contests.field.minParticipants': 'Participants minimum',
  'admin.contests.field.maxParticipants': 'Participants maximum',
  'admin.contests.field.paidPlaces': 'Places récompensées',
  'admin.contests.field.regOpens': 'Ouverture des inscriptions',
  'admin.contests.field.regCloses': 'Clôture des inscriptions',
  'admin.contests.field.startsAt': 'Début du concours',
  'admin.contests.field.endsAt': 'Fin du concours',
  'admin.contests.field.perQuestionSeconds': 'Secondes par question (0 = toute la fenêtre)',
  'admin.contests.field.tieBreak': 'Départage',
  'admin.contests.tieBreak.total_time': 'Temps de réponse total',
  'admin.contests.tieBreak.earliest_completion': 'Fin la plus précoce',
  'admin.contests.created': 'Concours créé en brouillon.',
  'admin.contests.prizePoolLabel': 'Cagnotte',
  'admin.contests.platformFeeLabel': 'Commission de la plateforme',
  'admin.contests.noPublicPage': 'Aucune page publique',
  'admin.contests.questions': 'Questions',
  'admin.contests.noQuestions': 'Aucune question pour le moment.',
  'admin.contests.addQuestion': 'Ajouter une question',
  'admin.contests.questionKind': 'Type de question',
  'admin.contests.kind.single_choice': 'Une seule bonne réponse',
  'admin.contests.kind.multi_choice': 'Plusieurs bonnes réponses',
  'admin.contests.kind.true_false': 'Vrai ou faux',
  'admin.contests.kind.numeric': 'Réponse numérique',
  'admin.contests.prompt': 'Question',
  'admin.contests.points': 'Points',
  'admin.contests.options': 'Options',
  'admin.contests.optionLabel': 'Option {n}',
  'admin.contests.correct': 'Correcte',
  'admin.contests.numericAnswer': 'Nombre correct',
  'admin.contests.numericTolerance': 'Tolérance acceptée',
  'admin.contests.hintLabel': 'Indice (facultatif)',
  'admin.contests.explanationLabel': 'Explication (affichée avec les résultats)',
  'admin.contests.saveQuestion': 'Enregistrer la question',
  'admin.contests.deleteQuestion': 'Supprimer la question',
  'admin.contests.answerKey': 'Corrigé',
  'admin.contests.unkeyed':
    "Certaines questions n'ont pas de bonne réponse définie. Corrigez-les avant de programmer.",
  'admin.contests.transitions': 'Cycle de vie',
  'admin.contests.action.schedule': 'Programmer le concours',
  'admin.contests.action.finalize': 'Figer les résultats',
  'admin.contests.action.publish': 'Publier les résultats',
  'admin.contests.action.cancel': 'Annuler le concours',
  'admin.contests.action.void': 'Invalider et rembourser',
  'admin.contests.cancelReason': 'Motif (enregistré)',
  'admin.contests.participants': 'Participants',
  'admin.contests.disqualify': 'Disqualifier',
  'admin.contests.disqualifyReason': 'Motif de la disqualification',
  'admin.contests.payments': 'Paiements des inscriptions',
  'admin.contests.payouts': 'Versements',
  'admin.contests.ledger': 'Grand livre',
  'admin.contests.transitionDone': 'Terminé.',


  'admin.payments.title': 'Paiements et versements',
  'admin.payments.subtitle':
    'Vérifiez les inscriptions, encaissez les paiements et libérez prix et remboursements.',
  'admin.payments.loadError': 'Impossible de charger les paiements.',
  'admin.payments.entry': 'Inscription',
  'admin.payments.provider': 'Prestataire',
  'admin.payments.reference': 'Référence',
  'admin.payments.settle': 'Enregistrer un encaissement',
  'admin.payments.settleAmount': 'Montant reçu',
  'admin.payments.settleNote': 'Note',
  'admin.payments.settleDone': 'Encaissement enregistré.',
  'admin.payments.resolve': 'Retirer le signalement',
  'admin.payments.resolveNote': "Qu'avez-vous constaté ?",
  'admin.payments.expire': "Faire expirer la facture",
  'admin.payments.flagged': 'Signalé pour rapprochement',
  'admin.payouts.title': 'Versements',
  'admin.payouts.empty': 'Aucun versement pour le moment.',
  'admin.payouts.approve': 'Approuver',
  'admin.payouts.process': 'Marquer en traitement',
  'admin.payouts.complete': 'Marquer comme payé',
  'admin.payouts.fail': 'Marquer comme échoué',
  'admin.payouts.failReason': "Pourquoi a-t-il échoué ?",
  'admin.payouts.cancel': 'Annuler le versement',
  'admin.payouts.createRefunds': 'Rembourser toutes les inscriptions confirmées',
  'admin.ledger.title': 'Grand livre',
  'admin.ledger.balances': 'Soldes par canal',
  'admin.ledger.note':
    "Les soldes sont par canal et par actif ; ils ne sont jamais additionnés entre canaux.",
  'admin.ledger.entryType': 'Type',
  'admin.ledger.direction': 'Sens',
  'admin.ledger.credits': 'Entrées',
  'admin.ledger.debits': 'Sorties',
  'admin.ledger.net': 'Net',

  'api.contestNotFound': "Ce concours n'existe pas.",
  'api.registrationClosed': 'Les inscriptions à ce concours sont closes.',
  'api.contestFull': 'Ce concours est complet.',
  'api.notEnrolled': "Vous n'êtes pas inscrit à ce concours.",
  'api.notActive': 'Vous ne participez pas actuellement à ce concours.',
  'api.entryNotConfirmed': "Votre inscription n'a pas encore été confirmée.",
  'api.contestNotLive': "Ce concours n'est pas ouvert à la participation.",
  'api.alreadyAnswered': 'Vous avez déjà répondu à cette question.',
  'api.submissionRejected': "Cette réponse n'a pas été acceptée — la fenêtre du concours est close.",
  'api.answerInvalid': "Cette réponse n'est pas valide pour cette question.",
  'api.resultsNotPublished': "Les résultats n'ont pas encore été publiés.",
  'api.rateLimited': 'Trop de requêtes. Patientez un instant puis réessayez.',
  'api.paymentNotFound': "Ce paiement n'existe pas.",
  'api.payoutNotFound': "Ce versement n'existe pas.",
  'api.notFinalized': 'Figez les résultats avant de les publier.',
  'api.reasonRequired': 'Un motif est requis.',
  'api.idempotencyKeyReused': 'Cette requête a déjà été utilisée pour une autre réponse.',
  'api.contestNotEditable': "Un concours ne peut être modifié qu'à l'état de brouillon.",
  'api.contentLocked': 'Le contenu du concours ne peut plus changer une fois le concours commencé.',
  'api.invalidAmount': 'Saisissez un montant valide, par ex. 10.00',
  'api.assetRailMismatch': "Cet actif n'appartient pas au canal de paiement sélectionné.",
  'api.unknownAsset': "Cet actif n'est pas pris en charge.",
  'api.invalidWindow': 'Les horaires des inscriptions et du concours ne sont pas dans un ordre valide.',
  'api.contestHasNoQuestions': 'Ajoutez au moins une question avant de programmer le concours.',
  'api.questionWithoutAnswerKey': 'Chaque question a besoin d’une bonne réponse avant la programmation.',
  'api.answerKeyRequired': 'Indiquez la bonne réponse de cette question.',
  'api.optionsRequired': 'Une question à choix nécessite au moins deux options.',
  'api.transitionContended': 'Le concours a changé pendant votre action. Rechargez et réessayez.',
  'api.invalidTransition': "Ce changement de cycle de vie n'est pas autorisé pour ce concours.",
  'api.notFlagged': "Ce paiement n'attend pas de rapprochement.",


  'pay.title': 'Payer en USDT',
  'pay.notIssued': "Aucun paiement n'est requis pour cette participation.",
  'pay.amount': 'Montant à envoyer',
  'pay.network': 'Réseau',
  'pay.address': 'Adresse de dépôt',
  'pay.copy': "Copier l'adresse",
  'pay.copied': 'Adresse copiée',
  'pay.openInWallet': 'Ouvrir dans le portefeuille',
  'pay.received': 'Reçu',
  'pay.confirmations': 'Confirmations',
  'pay.txHash': 'Transaction',
  'pay.viewOnExplorer': "Voir sur l'explorateur de blocs",
  'pay.expires': 'Payer avant',
  'pay.checkNow': "J'ai payé — vérifier maintenant",
  'pay.checking': 'Vérification de la blockchain…',
  'pay.autoCheck': 'Nous vérifions aussi la blockchain automatiquement.',
  'pay.qrLabel': "Code QR de l'adresse de dépôt",
  'pay.scanHint': 'Scannez avec votre portefeuille, ou copiez l’adresse.',
  'pay.awaitingHint':
    "Envoyez exactement ce montant d'USDT sur ce réseau à l'adresse ci-dessous. Cette adresse ne sert que pour cette participation.",
  'pay.detectedHint': 'Nous voyons votre transfert sur la blockchain.',
  'pay.confirmingHint':
    'Votre transfert est sur la blockchain et attend des confirmations. Votre participation s’activera automatiquement.',
  'pay.confirmedHint': 'Paiement confirmé. Vous participez à ce concours.',
  'pay.overpaidHint':
    'Paiement confirmé. Vous avez envoyé plus que les frais d’entrée ; l’excédent est enregistré pour vérification.',
  'pay.underpaidHint':
    'Le montant reçu est inférieur aux frais d’entrée. Envoyez le reste à la même adresse, ou contactez le support.',
  'pay.expiredHint':
    'Cette facture a expiré. Recommencez la participation pour obtenir une nouvelle adresse.',
  'pay.invalidHint':
    'Nous avons reçu un transfert non accepté pour cette participation (mauvais jeton ou réseau). Contactez le support.',
  'pay.failedHint':
    "Ce paiement n'a pas pu être associé à cette participation. Contactez le support.",
  'pay.status.awaiting_payment': 'En attente de paiement',
  'pay.status.detected': 'Détecté',
  'pay.status.confirming': 'Confirmation en cours',
  'pay.status.confirmed': 'Confirmé',
  'pay.status.underpaid': 'Sous-payé',
  'pay.status.overpaid': 'Surpayé',
  'pay.status.expired': 'Expiré',
  'pay.status.invalid': 'Non accepté',
  'pay.status.failed': 'Échoué',

  'login.google': 'Continuer avec Google',
  'login.or': 'ou',
  'login.staffNote':
    'La connexion par mot de passe reste disponible pour le personnel et les comptes existants.',
  'login.googleError.cancelled':
    'La connexion avec Google a été annulée. Vous pouvez réessayer quand vous le souhaitez.',
  'login.googleError.unavailable':
    "La connexion avec Google n'est pas disponible sur ce déploiement. Utilisez une autre méthode ou contactez le support.",
  'login.googleError.accountConflict':
    "Nous n'avons pas pu vous connecter avec ce compte Google, car il est déjà associé à un autre compte ITA6. Contactez le support.",
  'login.googleError.accountInactive': "Ce compte ITA6 n'est pas actif. Contactez le support.",
  'login.googleError.failed': "La connexion avec Google n'a pas abouti. Veuillez réessayer.",
  'register.google': 'Créer un compte avec Google',
  'nav.adminCrypto': 'Crypto',
  'admin.crypto.title': 'Console crypto',
  'admin.crypto.subtitle':
    "USDT on-chain : le pool d'adresses de dépôt, les factures, les transferts observés, les paiements sortants et le rapprochement.",
  'admin.crypto.loadError': 'Impossible de charger la console crypto.',
  'admin.crypto.rails': 'Canaux de paiement',
  'admin.crypto.railsDisabled': 'désactivé',
  'admin.crypto.networks': "Réseaux et adresses de dépôt",
  'admin.crypto.available': 'disponible(s)',
  'admin.crypto.unsupported': 'Non pris en charge',
  'admin.crypto.pool': "Pool d'adresses de dépôt",
  'admin.crypto.poolHint':
    "Chaque participation consomme une adresse de dépôt. Quand le pool est vide, les participations sont refusées plutôt que de recevoir une adresse impossible à rattacher — importez-en bien avant.",
  'admin.crypto.importNetwork': 'Réseau',
  'admin.crypto.importAsset': 'Jeton',
  'admin.crypto.poolFilter': 'Afficher',
  'admin.crypto.poolStatus.available': 'Disponible',
  'admin.crypto.poolStatus.assigned': 'Attribuée',
  'admin.crypto.poolStatus.retired': 'Retirée',
  'admin.crypto.import': 'Importer des adresses publiques',
  'admin.crypto.importPlaceholder': 'Une adresse par ligne',
  'admin.crypto.importHint':
    "Adresses PUBLIQUES uniquement — jamais de clé privée. Chaque ligne est validée selon le format réel de la chaîne, et une entrée invalide rejette l'import entier.",
  'admin.crypto.importButton': 'Importer les adresses',
  'admin.crypto.importEmpty': 'Collez au moins une adresse.',
  'admin.crypto.imported': '{count} adresse(s) importée(s). {available} désormais disponible(s).',
  'admin.crypto.address': 'Adresse',
  'admin.crypto.network': 'Réseau',
  'admin.crypto.status': 'Statut',
  'admin.crypto.assignedTo': 'Attribuée à',
  'admin.crypto.empty': 'Rien à afficher.',
  'admin.crypto.runMonitor': 'Lancer la surveillance',
  'admin.crypto.monitorDone': 'Surveillance terminée : {examined} examinées, {settled} réglées.',
  'admin.crypto.signer': 'Signature des paiements',
  'admin.crypto.signerReady': 'Signataire configuré',
  'admin.crypto.signerMissing':
    "Aucun signataire configuré — les paiements ne peuvent pas être diffusés automatiquement. Ils peuvent toujours être envoyés manuellement et le hachage enregistré.",
  'admin.crypto.payoutWallet': 'Portefeuille de paiement',
  'admin.crypto.payoutWalletMissing': 'Non configuré',
  'admin.crypto.emulator': 'Émulateur de chaîne',
  'admin.crypto.emulatorOn': 'Activé — répétition uniquement, jamais en production',
  'admin.crypto.emulatorOff': 'Désactivé',
  'admin.crypto.emulatorQueued': '{count} observation(s) en attente',
  'admin.crypto.stuck': 'Paiements nécessitant une action',
  'admin.crypto.recheck': 'Vérifier maintenant',
  'admin.crypto.recheckDone': 'Vérifié à nouveau sur la chaîne.',
  'admin.crypto.invoices': 'Factures crypto',
  'admin.crypto.participant': 'Participant',
  'admin.crypto.expected': 'Attendu',
  'admin.crypto.received': 'Reçu',
  'admin.crypto.confirmations': 'Confirmations',
  'admin.crypto.depositAddress': 'Adresse de dépôt',
  'admin.crypto.txHash': 'Transaction',
  'admin.crypto.amount': 'Montant',
  'admin.crypto.classification': 'Classé comme',
  'admin.crypto.from': 'De',
  'admin.crypto.transfers': 'Transferts observés sur la chaîne',
  'admin.crypto.reconciliation': 'Rapprochement',
  'admin.crypto.reconciliationHint':
    "Ce que nous avons enregistré face à ce que dit la chaîne. Un écart non nul est signalé, jamais corrigé en silence.",
  'admin.crypto.applicationIn': 'Enregistré entrant',
  'admin.crypto.applicationOut': 'Enregistré sortant',
  'admin.crypto.observed': 'Observé sur la chaîne',
  'admin.crypto.discrepancy': 'Écart',
  'admin.crypto.notReadable': 'illisible depuis la chaîne',
  'admin.crypto.unmatched': 'Transferts non rapprochés',
  'admin.crypto.payoutsHint': 'approuvez, signez et réglez les paiements là-bas.',
  'admin.crypto.mode': 'Signature',
  'admin.crypto.mode.inWorker': 'dans le Worker',
  'admin.crypto.mode.externalSigner': 'signataire externe',
  'admin.crypto.mode.manualOnly': 'manuel uniquement',
  'legal.privacy': 'Politique de confidentialité',
  'legal.terms': 'Conditions générales',
  'legal.lastUpdated': 'Dernière mise à jour {date}',
  'legal.authoritativeNote':
    'Ce document est fourni en plusieurs langues. En cas de divergence avec le texte anglais, la version anglaise fait foi.',

};
